import React from 'react';

import { EN_IN } from '../../utils/geo-space-id-helpers';

import Layout from '../../components/layout';
import { renderSearchPage } from '../../templates/search';

const Search = () => {
  const GEO_SPACE = EN_IN;
  const seoSlug = `${GEO_SPACE}/search`;

  return <Layout>{renderSearchPage(GEO_SPACE, seoSlug)}</Layout>;
};

export default Search;
